import React from 'react';
import {
  DirectionsLink,
  H3,
  Paragraph,
  StackedColumn,
  StackedColumnSpacing,
} from '../../../core';

interface LocationProps {
  facilityName: string;
  streetAddress: string;
  city: string;
  state: string;
  zipCode: string;
}

const Location: React.FC<LocationProps> = (props: LocationProps) => {
  return (
    <StackedColumn spacing={StackedColumnSpacing.NoGap}>
      <H3 text="LOCATION" />
      <Paragraph text={props.facilityName} bold={true} />
      <Paragraph text={props.streetAddress} />
      <Paragraph text={`${props.city}, ${props.state} ${props.zipCode}`} />
      <DirectionsLink
        street1={props.streetAddress}
        city={props.city}
        state={props.state}
        zipcode={props.zipCode}
      />
    </StackedColumn>
  );
};

export default Location;
